module.exports = __webpack_public_path__ + "public/images/icons/net.9140e32a2d2494e3be04f5dba028c591.png";